var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Auth, Layout, Dependencies } from "~/core/decorator";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import { TemplateService } from "~/services/domain-service/template.service";
import LetterTemplateConfig from '~/components/template-manage/letter-template/letter-template-config.vue';
var LetterTemlate = /** @class */ (function (_super) {
    __extends(LetterTemlate, _super);
    function LetterTemlate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.templateDataSet = [];
        _this.dialog = {
            modify: false
        };
        _this.selectedRow = null;
        _this.dataModel = {
            templateName: '',
            templateCode: '',
            templateStatus: '',
            distributeType: '',
            templateCategory: 'CONTRACT',
        };
        return _this;
    }
    LetterTemlate.prototype.mounted = function () {
        this.refreshData();
    };
    LetterTemlate.prototype.refreshData = function () {
        var _this = this;
        this.templateService.getTemplatesByCondition(this.dataModel, this.pageService, this.sortService).subscribe(function (data) { return _this.templateDataSet = data; });
    };
    LetterTemlate.prototype.deleteTemplate = function (rowData) {
        var _this = this;
        this.$confirm("\u60A8\u786E\u5B9A\u8981\u5220\u9664\u8BE5\u6A21\u677F\u5417\uFF1F", '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        }).then(function () {
            _this.templateService.deleteTemplateById(rowData.id)
                .subscribe(function (data) {
                _this.$message.success('删除成功');
                _this.refreshData();
            });
        });
    };
    __decorate([
        Dependencies(SortService)
    ], LetterTemlate.prototype, "sortService", void 0);
    __decorate([
        Dependencies(PageService)
    ], LetterTemlate.prototype, "pageService", void 0);
    __decorate([
        Dependencies(TemplateService)
    ], LetterTemlate.prototype, "templateService", void 0);
    LetterTemlate = __decorate([
        Auth(1605),
        Layout("workspace"),
        Component({
            components: {
                LetterTemplateConfig: LetterTemplateConfig,
            }
        })
    ], LetterTemlate);
    return LetterTemlate;
}(Vue));
export default LetterTemlate;
